import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useTestKlaviyoIntegration(shop: ShopDto) {
  const invalidateShop = useInvalidateShop(shop.id);

  return useApiMutation<"post", "/shops/{shopId}/integrations/klaviyo/test", void>(
    "post",
    "/shops/{shopId}/integrations/klaviyo/test",
    {
      invalidate: invalidateShop,
      mapVariables: () => ({
        params: { path: { shopId: shop.id } },
      }),
    },
  );
}
